export default __webpack_public_path__ + "static/media/1385.1274695b.png";